import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-return-suspend-request-details',
  templateUrl: './return-suspend-request-details.component.html',
  styleUrls: ['./return-suspend-request-details.component.scss']
})
export class ReturnSuspendRequestDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
